import { render, staticRenderFns } from "./OpeningsMail.vue?vue&type=template&id=13d71a87&scoped=true&"
import script from "./OpeningsMail.vue?vue&type=script&lang=js&"
export * from "./OpeningsMail.vue?vue&type=script&lang=js&"
import style0 from "./OpeningsMail.vue?vue&type=style&index=0&id=13d71a87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d71a87",
  null
  
)

export default component.exports